import { cn } from "@/lib/utils";

export const Stepper = ({
  steps,
  current,
  onStep
}: {
  steps: number;
  current: number;
  onStep?: (step: number) => void;
}) => (
  <div className="inline-flex flex-col items-center gap-3">
    <div className="flex items-center gap-2">
      {Array.from({ length: steps }).map((_, step) => {
        const isComplete = step < current;
        const isCurrent = step === current;
        const isClickable = isComplete && !!onStep;
        return (
          <button
            key={step}
            type="button"
            disabled={!isClickable}
            aria-label={`Go to step ${step + 1}`}
            aria-current={isCurrent ? "step" : undefined}
            onClick={() => {
              if (isClickable && onStep) {
                onStep(step);
              }
            }}
            className={cn(
              "group flex h-6 w-14 items-center rounded-full outline-none",
              "focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background",
              isClickable ? "cursor-pointer" : "cursor-default"
            )}
          >
            <span
              className={cn(
                "h-1.5 w-full rounded-full transition-colors duration-300",
                isCurrent
                  ? "bg-primary"
                  : isComplete
                    ? "bg-primary/40 group-hover:bg-primary/70"
                    : "bg-border"
              )}
            />
          </button>
        );
      })}
    </div>

    <p className="text-sm tabular-nums text-muted-foreground">
      Step {current + 1} of {steps}
    </p>
  </div>
);
